import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import pdfMake from 'pdfmake/build/pdfmake';
import {
	deletePaymentReceived,
	fetchPaymentReceivedDetails,
} from '../../../../../services/payments_received';
import { generatePaymentReceivedPdf } from '../components/generatePaymentsReceivedPdf';
import UsePaymentReceived from './usePaymentReceived';
import { useSelector } from 'react-redux';

const UsePaymentReceivedDetails = () => {
	const [prDetails, setPRDetails] = useState([]);
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const { handlePrintAndDownloadPdf } = UsePaymentReceived();
	const [isDeletePaymentReceivedModalOpen, setIsDeletePaymentReceivedModalOpen] = useState(false);
	const [loading, setLoading] = useState(true);
	const param = useParams();
	const id = param?.id;
	const navigate = useNavigate();
	const suburl = localStorage.getItem('suburl');

	async function getPaymentReceivedDetails() {
		try {
			setLoading(true);
			var { payment_receive } = await fetchPaymentReceivedDetails({ ids: [id] });
			if (payment_receive) {
				setPRDetails(payment_receive);
			}
		} catch (error) {
			console.log(error);
			// toast.error('Something went wrong!');
		} finally {
			setLoading(false);
		}
	}
	async function handleDeletePaymentReceived() {
		try {
			await deletePaymentReceived(id);
			toast.success('Payments Received deleted successfully');
			navigate(`/user/${suburl}/payments-received`);
		} catch (error) {
			toast.error('Something went wrong!');
		}
	}

	async function generateSalesPaymentReceivedPdf(type = 'print', merge = false) {
		try {
			await handlePrintAndDownloadPdf(id, type, merge);
		} catch (error) {}
	}

	useEffect(() => {
		if (id) {
			getPaymentReceivedDetails();
		}
	}, [id]);

	return {
		user,
		prDetails,
		loading,
		navigate,
		id,
		suburl,
		setIsDeletePaymentReceivedModalOpen,
		isDeletePaymentReceivedModalOpen,
		handleDeletePaymentReceived,
		generateSalesPaymentReceivedPdf,
		getPaymentReceivedDetails,
	};
};

export default UsePaymentReceivedDetails;
